// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__209rB","heading-title":"Heading_heading-title__qYGI5","heading-subtitle":"Heading_heading-subtitle__zjqWc"};